import React from 'react';
import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

const chipClassMap = {
  Manual: 'manual-chip',
  Calculated: 'calculated-chip',
  Automation: 'automation-chip',
  Default: 'default-chip',
  Bulk: 'bulk-chip',
  Overridden: 'overridden-chip',
};

const UpdateSourceChip = ({ label }) => {
  const chipClass = chipClassMap[label];
  return (
    <Chip
      label={label}
      className={chipClass}
      sx={{
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        borderRadius: '8px',
        width: 'fit-content',
        justifyContent: 'center',
      }}
    />
  );
};

UpdateSourceChip.propTypes = {
  label: PropTypes.string.isRequired,
};
export default UpdateSourceChip;
